/**
 * @packageDocumentation
 * @module object
 * @preferred
 */
export function objectEntries(obj) {
    return Object.entries(obj);
}
